import React, {Component} from 'react';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../Header';
import logo_img from './../assets/images/maintenance_window.jpg';
class MaintenanceWindow extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            maintenance: 0
        }
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    back() {
        window.location.href = '/login/';
    }

    render() {
        if (this.state.redirect) {
            return (
                    <Redirect to={'/login'} />
                    )
        }
        return(
                <div>
        {this.state.maintenance == 1 ?
                <div>
                    <Header brecum_name="" brecum_page=""/>
                    <div class="right_col">
                        <div class="intranet_body maintainance-window">
                            <img src={logo_img}/>
                        </div>
                    </div>
                </div>
                :
                <div></div>
                }
                </div>
                )
    }
    componentDidMount() {
        if (!localStorage.getItem('userLogin')) {
            this.setState({redirect: true});
        }
        fetch(this.state.apiUrl + '/Site/maintenanceWindow/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((responseJson) => {
                    console.log('findresponse', responseJson);
                    if (responseJson.code == 200) {
                        this.setState({
                            maintenance: responseJson.maintenance
                        },function(){
                           this.props.hasOwnProperty("receive") ? this.props.receive(this.state.maintenance):"";
                        })
                    }
                })
    }
}

export default MaintenanceWindow;



// WEBPACK FOOTER //
// ./src/components/MaintenanceWindow.js